import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-navigate-back',
  standalone: false,
  template: `
        <div class="w-min">
        <button
          type="button"
          (click)="handleBackOrExit()"
          class="flex items-center text-sm sm:text-sm"
          [ngClass]="textColorClass"
        >
          <i class="bx bx-chevron-left text-xl sm:text-3xl"></i>
          Back
        </button></div>
  `
})
export class NavigateBackComponent {

  /**
   * Tailwind text color class
   * Default: text-white
   * Example override: text-gray-800, text-black
   */
  @Input() textColorClass: string = 'text-white';

  constructor(private location: Location) { }

  handleBackOrExit(): void {
    try {
      if ((window as any).Android?.exitWebView) {
        (window as any).Android.exitWebView();
        return;
      }

      if ((window as any).webkit?.messageHandlers?.exitWebView) {
        (window as any).webkit.messageHandlers.exitWebView.postMessage({});
        return;
      }

      this.location.back();
    } catch (error) {
      console.error('WebView exit error:', error);
      this.location.back();
    }
  }
}
